import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-number-four-icon',
  templateUrl: './number-four-icon.component.html',
  styles: []
})
export class NumberFourIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
